import mainRoutes from "@/app/client/main/main-routes";
import loginRoutes from '@/app/client/login/login-routes';
import documentsRoutes from '@/app/client/documents/documents-routes';

const clientRoutes = [
  ...mainRoutes,
  ...loginRoutes,
  ...documentsRoutes
];

export default clientRoutes;
